import React from 'react';
import { useLoaderData } from 'react-router-dom';
import ManageUser from 'components/ManageUser';
import { getUser } from 'api/users';

const userQuery = (id) => ({
    queryKey: ['users', id],
    queryFn: async () => getUser(id),
});

export const loader =
    (queryClient) =>
    async ({ params }) => {
        const query = userQuery(params.userId);
        return queryClient.getQueryData(query) ?? (await queryClient.fetchQuery(query));
    };

export default function AdminEditUser() {
    const user = useLoaderData();

    return (
        <div data-testid="route-users-edit">
            <ManageUser user={user} action={'update'} />
        </div>
    );
}
